import ButtonLargeMixin from './mixins/button-large-mixin.js';
import ButtonTextMixin from './mixins/button-text-mixin.js';
import TpButton from './tp-button.js';

class TpButtonTextLarge extends
  ButtonLargeMixin(
  ButtonTextMixin(
    TpButton
  )) {}

export default TpButtonTextLarge;


